import { GridifyQueryBuilder as i } from "../../../../node_modules/gridify-client/dist/index.esm.js";
import { serializeComparison as r, isComparison as e } from "./serializeComparison.js";
import { serializeComplex as o, isComplex as s } from "./serializeComplex.js";
import { serializeDate as t, isDate as m } from "./serializeDate.js";
import { serializePrimitive as a, isPrimitive as l } from "./serializePrimitive.js";
import { serializeTextSearch as f, isTextSearch as n } from "./serializeTextSearch.js";
import { isLastValue as p } from "./utils/isLastValue.js";
import { makeCondition as u } from "./utils/makeCondition.js";
import { hasItemValue as d } from "./utils/hasItemValue.js";
const j = [u(l, a), u(s, o), u(m, t), u(n, f), u(e, r)], z = (i2, r2) => {
  for (const { shouldSerialize: e2, serialize: o2 } of j) if (e2(i2)) return o2(i2, r2);
}, c = (r2) => {
  const e2 = new i();
  return r2.filter(d).forEach((i2, r3, o2) => {
    z(i2, e2), p(o2, r3) || e2.and();
  }), e2;
};
export {
  c as buildGridifyQuery,
  z as serializeFilterItem
};
//# sourceMappingURL=buildGridifyQuery.js.map
